import LoadMoreDisplayText from './LoadMoreDisplayText';

export default LoadMoreDisplayText;
